import config from '../../config'
import { message } from 'ant-design-vue/es'
import axios from 'axios'
import moment from 'moment'
import fileDownload from 'js-file-download'

export const header = (isFile) => {
  const token = sessionStorage.getItem('token') || ''
  if(isFile)
  {
    return {
      //'Content-Type': 'multipart/form-data',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }
}
export const valid = async() => {
  const expireTime = moment(parseInt(sessionStorage.getItem('expireTime')) || '')
  if (moment().isAfter(expireTime)) {
    //  超过有效期时间
    alert('请登录')
    window.location.href = '#/login'
    return false
  } else if (moment().add(10, 'm').isAfter(expireTime)) {
    //  还有10分钟过期
    const data = await refreshToken()
    sessionStorage.setItem('token', data.token)
    sessionStorage.setItem('expireTime', data.expireTime)
    return true
  } else {
    return true
  }
}

export const refreshToken = async() => {
  // const token = sessionStorage.getItem('token') || ''
  return await apiRefreshToken()
}

export const ajax = async(opt) => {
  var opts = opt || {}, response

  if (!opts.isFile&&!opts.url) {
    console.log('请填写接口地址')
    return
  }

  opts.type = opts.type.toUpperCase() || 'POST'
  opts.data = opts.data || {}
  opts.isFile=opts.isFile || false

  await axios({
    method: opts.type,
    url: opts.url,
    params: (opts.type === 'GET') ? opts.data : {},
    data: (opts.type === 'POST' || opts.type === 'PUT' || opts.type === 'DELETE') ? opts.data : {},
    headers: opts.headers || header(opts.isFile),
    baseURL: (config.isMock && config.debug) ? config.base.mock : opts.isFile?config.base.fileUrl: config.base.url,
    timeout: opts.time || 30 * 1000,
    responseType: opts.dataType || 'json'
  }).then((res) => {
    if (config.isMock && config.debug) {
      response = res.data
    } else {
      if (res.status === 200) {
        if (res.data.success) {
          response = res.data.result || true
        } else {
          response = false
          message.error(res.data.error.message + (res.data.error.details != null ? res.data.error.details : ''))
        }
      } else if (res.status === 500) {
        response = false
        message.error(res.data.error.message + (res.data.error.details != null ? res.data.error.details : ''))
      } else {
        response = false
        message.error('系统繁忙，请联系管理员')
      }
    }
  }).catch(function(error) {
    if (error&&error.response&&error.response.status && error.response.status === 401) {
      message.error('请登录')
      response = false
      window.location.href = '#/login'
    }
    else if(error&&error.response&&error.response.status === 403)
    {
      response = false
      message.error(error.response.data.error.message + (error.response.data.error.details != null ? error.response.data.error.details : ''))
    }
    else if (error&&error.response&&error.response.status === 500) {
      response = false
      message.error(error.response.data.error.message  + (error.response.data.error.details != null ? error.response.data.error.details : ''))
    } else {
      response = false
      message.error('系统繁忙，请联系管理员')
    }
  })
  return response
}

export const serviceAjax = async(data = {}) => {
  const tokenValid = await valid()
  if (tokenValid) {
    return await ajax(data)
  } else {
    return false
  }
}
export const downloadAjax = async(data = {}) => {
  const tokenValid = await valid()
  if (tokenValid) {
    return await axios({
      method: data.type,
      url: data.url,
      baseURL: config.base.url,
      headers: header(false),
      responseType: 'blob'
    }).then(response => {
      if (!response) {
        return
      }
      fileDownload(response.data, data.fileName)
    }).catch((error) => {
      if (error && error.response && error.response.status && error.response.status === 401) {
        message.error('请登录')
        window.location.href = '#/login'
      } 
      else if(error&&error.response&&error.response.status === 403)
      {
        message.error(error.response.data.error.message + (error.response.data.error.details != null ? error.response.data.error.details : ''))
      }
      else if (error && error.response && error.response.status === 500) {
        message.error(error.response.data.error.message + (error.response.data.error.details != null ? error.response.data.error.details : ''))
      } else if (error && error.response && error.response.status === 404) {
        message.error('找不到指定的文件')
      } else {
        message.error('系统繁忙，请联系管理员')
      }
    })
  } else {
    return false
  }
}

export const apiRefreshToken = async(data = {}) => {
  const response = await ajax({
    url: '/api/User/refreshToken',
    type: 'post',
    data
  })
  return response
}


// WEBPACK FOOTER //
// ./src/common/api/base.js